import React, { useEffect } from 'react';
import '../Assets/Css/home.css';
import { Container, Row, Col, Button, } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { Helmet } from 'react-helmet';
// import leftaboutsection from '../Assets/Image/trident-home-about.jpg';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useNavigate } from 'react-router-dom';
import { FaAnglesRight } from "react-icons/fa6";
import { FaRecycle, FaLeaf, FaBuilding } from 'react-icons/fa';

import aboutsection from '../Assets/Images/aboutimge.avif'
import leftaboutsection from '../Assets/Images/earthpalnets.avif'
import rightaboutsection from '../Assets/Images/hands-plant-soil.jpeg'
import CircularImg from '../Assets/Images/tree-leaves-arrows.jpeg'
import SoilImg from '../Assets/Images/hands-plant-soil.jpeg';
import JobImg from '../Assets/Images/traffic-signs-place-name-sign-success-.jpeg'
import sectionimg1 from '../Assets/Images/section11.avif'
import sectionimg2 from '../Assets/Images/people-peace-mankind.jpeg'

import img1 from '../Assets/Images/hamdshakeregards.png'
import img2 from '../Assets/Images/industryweb.jpg'
import img3 from '../Assets/Images/limb-males-meet-meeting.jpeg'
import img4 from '../Assets/Images/tractor-mower-pasture.jpeg'
import img5 from '../Assets/Images/villagefieldview.avif'

export default function HomePage() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
    AOS.refresh();
  }, []);

  const navigate = useNavigate();

  const regenerativeValues = [
    {
      icon: <FaRecycle size={40} color="#6c63ff" />,
      title: 'Circular Economies',
      description:
        'Circular Economies create positive feedback loops. Effective waste management systems not only restore our planet, but provide humanitarian wellness and shared economic benefits. Together we can close market gaps.',
      image: CircularImg,
      alt: 'Circular Economy',
    },
    {
      icon: <FaLeaf size={40} color="#28a745" />,
      title: 'Soil Remediation and Regenerative Agriculture',
      description:
        'Healthy soil is living soil. Growing living soil is the foundation to agricultural security, crop yield, nutrient density, water retention and more. Improving global security begins with the soil.',
      image: SoilImg,
      alt: 'Soil Regeneration',
    },
    {
      icon: <FaBuilding size={40} color="#f0ad4e" />,
      title: 'Community Development and Job Creation',
      description:
        "With great change comes great outcomes. Sustainable development brings ongoing opportunities for the region and its diverse people. Effective community engagement and inclusion ensures regional support and long-term success.",
      image: JobImg,
      alt: 'Job Creation',
    },
  ];




  const testimonials = [
    "Mobius Unity helped us scale our regenerative agriculture practices by offering strategic insights and data-driven planning. Their team truly understands how to blend nature-based solutions with innovation.",
    "The technical and operational support from Mobius Unity was crucial to our success in deploying water-saving technologies in remote communities. Their collaborative approach made all the difference.",
    "Their strategic planning and risk assessment services gave us a clear roadmap to scale our solar microgrid systems. They don't just consult — they become part of your journey.",
    "Mobius Unity’s work on sustainable community models and business-government engagement has set a new benchmark in how private organizations support public initiatives.",
    "From market strategy to operations, their team brought structure and momentum to our vision. Mobius Unity's values align perfectly with impact-driven entrepreneurs like us.",
  ];

  const services =[
    img1,img2,img3,img4,img5
  ]



  return (
    <>
      <div>

 <Helmet>
      {/* Page Title */}
      <title>Mobius Unity Consulting | Empowering Communities for a Sustainable Future</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="Mobius Unity Consulting empowers communities through regenerative agriculture, circular economies, sustainable development, and innovative solutions for people and the planet."
      />

      {/* Keywords */}
      <meta
        name="keywords"
        content="Mobius Unity, sustainable development, regenerative agriculture, circular economy, soil remediation, renewable energy, water technology, eco-engineering, community development, sustainability consulting"
      />

      {/* Author */}
      <meta name="author" content="Mobius Unity Consulting" />

      {/* Open Graph Tags */}
      <meta property="og:title" content="Mobius Unity Consulting | Empowering Communities" />
      <meta
        property="og:description"
        content="Mobius Unity delivers smart, sustainable solutions for communities, businesses, and agencies focused on long-term security for people and the planet."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://mobiusunityconsulting.com" />
      <meta property="og:image" content="https://mobiusunityconsulting.com/og-image.jpg" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Mobius Unity Consulting" />
      <meta
        name="twitter:description"
        content="Sustainable consulting services for regenerative agriculture, clean water, renewable energy, and community development."
      />
      <meta name="twitter:image" content="https://mobiusunityconsulting.com/twitter-image.jpg" />
      <meta name="twitter:creator" content="@MobiusUnity" />
    </Helmet>



        <div className="banner1-section d-flex  align-items-center justify-content-center">
          <div className="banner1-overlay text-center">
            <h2 className="banner1-title" data-aos="zoom-in" data-aos-delay="100">
              Welcome to Mobius Unity Consulting
            </h2>
            <h4 data-aos="zoom-in" data-aos-delay="200">Planet-Mechanics and Eco-Engineers</h4>
            <Button variant="light" className="banner1-button mt-5" href='/services'
              data-aos="zoom-in" data-aos-delay="300">
              Explore Services <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
            </Button>
          </div>
        </div>

        <section className="about-section " style={{ marginTop: '40px' }}>
          <Container>
            <Row className="text-center section-heading" data-aos="fade-down" data-aos-delay="100">
              <Col>
                <h3 className="fw-bold section-title">
                  Empowering Communities for <br />
                  <span style={{ color: '#04A1D3' }}> a Sustainable Future</span>
                  <span className="title-decoration">  </span>
                </h3>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={3} className="mb-4 mb-md-0" data-aos="zoom-in" data-aos-delay="200">
                <img
                  src={leftaboutsection}
                  alt="mobiusunity"
                  className="img-fluid rounded"
                />
              </Col>

              <Col xs={12} md={6} className="aboutmid text-center text-md-start" data-aos="fade-up" data-aos-delay="300">

                <h5 className="text-center" style={{ lineHeight: '2' }} >
                  Providing support to community leaders, developers, families, businesses, non-profits, agencies, and individuals we implement innovative solutions for long-term security for people and the planet.
                </h5>
              </Col>


              <Col xs={12} md={3} className="rightimage" data-aos="zoom-in" data-aos-delay="500">
                <img
                  src={rightaboutsection}
                  alt="mobiusunity"
                  className="img-fluid rounded mb-3"
                />
              </Col>
            </Row>
          </Container>
        </section>

        <section className="mobius-section py-5" style={{ backgroundColor: '#F8FBFF' }}>
          <Container>
            <Row className="text-center mb-5" data-aos="fade-down">
              <Col>
                <h3 className="fw-bold section-title">
                  Getting Further,<span style={{ color: '#04A1D3' }}>Together</span>
                  <span className="title-decoration">  </span>
                </h3>
              </Col>
            </Row>

            <Row className="align-items-center">
              <Col xs={12} md={5} d data-aos="zoom-in" >
                <img
                  src={aboutsection} 
                  alt="Collaboration for Sustainable Growth"
                  className="img-fluid rounded shadow-sm"
                />
              </Col>

              <Col xs={12} md={7} className="mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay="100">
                <div className="text-md-start text-center" style={{ fontSize: '16px' }}>
                  <p className=" mb-3">
                    At <strong>Mobius</strong>, our mission is to co-create lasting value for people and planet wellness. We work with a wide range of clients to provide <strong>analysis, strategic planning, development systems, marketing and sales,</strong> and <strong>management services</strong> for long-term operational growth and success.
                  </p>
                  <p className="">
                    Our services are designed to help clients thrive while positively impacting the environment and the communities they serve. Let us help you achieve <strong>sustainable growth</strong>.
                  </p>
                  <Button variant="outline-primary" size="md" className="rounded-pill mt-3">
                    Get Contact <FaAnglesRight />
                  </Button>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="py-5" style={{ backgroundColor: '		#f5fafd' }}>
          <Container>
            <Row className="text-center mb-4" data-aos="fade-down" data-aos-delay="100">
              <Col>
                <h3 className="fw-bold section-title">
                  Co-creating Regenerative<span style={{ color: '#04A1D3' }}> Values</span>
                  <span className="title-decoration">  </span>
                </h3>
              </Col>
            </Row>

            <Row className="text-center">
              {regenerativeValues.map((item, index) => (
                <Col xs={12} md={4} className="mb-5" key={index} data-aos="zoom-in">
                  {/* Card Content */}
                  <div className="regerativecard h-100 p-5 border-0 ">
                    <div className=" regerativeicons">{item.icon}</div>
                    <h5 className="fw-bold">{item.title}</h5>
                    <p className="text-muted">{item.description}</p>
                  </div>
                </Col>
              ))}

              {regenerativeValues.map((item, index) => (
                <Col xs={12} md={4} className="" key={index} data-aos="zoom-in" data-aos-delay="100">

                  {/* Image Outside the Card */}
                  <div className="mb-5 " data-aos="zoom-in" data-aos-delay="200">
                    <img
                      src={item.image}
                      alt={item.alt}
                      className="img-fluid regerativeimg rounded"
                      style={{ height: '230px', width: '100%', objectFit: 'cover' }}
                    />
                  </div>
                </Col>
              ))}

            </Row>
          </Container>
        </section>

<section className="testimonial-carousel-section my-5">
  <div className="container py-3">
    <Row className="align-items-center justify-content-center flex-md-row m-0">
      <h3
        className="fw-bold text-center section-title"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        A Service Culture that takes{' '}
        <span style={{ color: '#04A1D3' }}>Concepts to Delivery</span>
        <span className="title-decoration mb-2"></span>
      </h3>
      <p
        className="text-muted text-center"
        style={{ maxWidth: 700 }}
        data-aos="fade-down"
        data-aos-delay="100"
      >
        {/* Optional description */}
      </p>

      <Col
        xs={12}
        md={12}
        className="text-center order-1 order-md-2"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        {/* <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={30}
          loop={true}
          slidesPerView={4} 
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          navigation={true}
          className="testimonial-swiper"
        >
          {services.map((imgSrc, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={imgSrc}
                alt={`Service ${idx + 1}`}
                className="img-fluid rounded shadow-sm mb-5"
                style={{ height: '200px',width:'100%', objectFit: 'cover' }}
              />
            </SwiperSlide>
          ))}
        </Swiper> */}
        <Swiper
  modules={[Autoplay, Pagination, Navigation]}
  spaceBetween={30}
  loop={true}
  breakpoints={{
    0: {
      slidesPerView: 2, // 👈 For mobile screens (0px and up)
    },
    768: {
      slidesPerView: 3, // 👈 For tablets and small desktops
    },
    992: {
      slidesPerView: 4, // 👈 For larger desktops
    },
  }}
  autoplay={{
    delay: 2000,
    disableOnInteraction: false,
  }}
  pagination={{ clickable: true }}
  navigation={true}
  className="testimonial-swiper"
>
  {services.map((imgSrc, idx) => (
    <SwiperSlide key={idx}>
      <img
        src={imgSrc}
        alt={`Service ${idx + 1}`}
        className="img-fluid rounded shadow-sm mb-5"
        style={{ height: '200px', width: '100%', objectFit: 'cover' }}
      />
    </SwiperSlide>
  ))}
</Swiper>

      </Col>
    </Row>
  </div>
</section>

        <section className="py-5 innovation-support-section">
          <Container>
            <Row className="text-center mb-4" data-aos="fade-down" data-aos-delay="100">
              <Col>
                <h3 className="fw-bold section-title">
                  <span style={{ color: 'white' }}>Supporting the Growth of</span>
                  <span style={{ color: 'black' }}> Innovative Industries</span>
                </h3>
                <p className="text-warning">
                  Driving sustainable transformation through industry-focused expertise and collaborative support.
                </p>
              </Col>
            </Row>

            <Row>
              {/* Left Column: First Data */}
              <Col md={4} className="mb-4" data-aos="zoom-in">
                <div className="p-4 h-100 bg-white rounded shadow-sm">
                  <h5 className="fw-bold mb-3 text-center text-success">Our Focused Industries</h5>
                  <ul className="list-unstyled text-muted" style={{ lineHeight: '2.5' }}>
                    <li>• Soil Remediation and Regenerative Agriculture Practices</li>
                    <li>• Food & Feed Production</li>
                    <li>• Water Technologies</li>
                    <li>• Renewable Fuels and Energies</li>
                    <li>• Textiles and Construction Materials</li>
                    <li>• Nutraceuticals and Natural Medicines</li>
                    <li>• Sustainable Community Development</li>
                  </ul>
                </div>
              </Col>

              {/* Middle Column: Images */}
              <Col md={4} className="mb-4 d-flex flex-column gap-3" >
                <img
                  src={sectionimg1}
                  alt="Industry Image 1"
                  className="img-fluid rounded shadow-sm"
                  data-aos="zoom-in" data-aos-delay="100"
                  style={{width:'100%',height:'220px'}}
                />
                <img
                  src={sectionimg2}
                  alt="Industry Image 2"
                  className="img-fluid rounded shadow-sm"                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
                  data-aos="zoom-in" data-aos-delay="1 00"
                   style={{width:'100%',height:'220px'}}
                />

              </Col>

              {/* Right Column: Second Data */}
              <Col md={4} className="mb-4" data-aos="zoom-in" data-aos-delay="300">
                <div className="p-4 h-100 bg-white rounded shadow-sm">
                  <h5 className="fw-bold mb-3 text-center text-success">Our Supports</h5>
                  <ul className="list-unstyled text-muted" style={{ lineHeight: '2.5' }}>
                    <li>• Data Analysis and Science</li>
                    <li>• Risk Assessments</li>
                    <li>• Strategic Planning</li>
                    <li>• Development Systems</li>
                    <li>• Marketing and Sales</li>
                    <li>• Management Services and Operations</li>
                    <li>• Business and Government Relations</li>
                    <li>• Resource Aggregation</li>
                  </ul>
                </div>
              </Col>

            </Row>
            <div className="text-center mt-4">
              <Button variant="outline-success bg-warning" size="md" className="rounded-pill mt-3">
                Contact Now <FaAnglesRight />
              </Button>

            </div>
          </Container>
        </section>




        <section className="testimonial-carousel-section my-5">
          <div className="container py-3 ">
            <Row className="align-items-center justify-content-center flex-md-row m-0">
              <h3 className="fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
                Empowering <span style={{ color: '#04A1D3' }}>Innovation</span>
                <span className="title-decoration mb-2"></span>
              </h3>
              <p className="text-muted text-center" style={{ maxWidth: 700 }} data-aos="fade-down" data-aos-delay="100">
                we deliver smart solutions that empower growth and innovation.
              </p>
              <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

                <Swiper
                  modules={[Autoplay, Pagination, Navigation]}
                  spaceBetween={30}
                  loop={true}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  pagination={{ clickable: true }}
                  navigation={true}
                  className="testimonial-swiper"
                >
                  {testimonials.map((text, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="stars mb-1">
                        {[...Array(5)].map((_, i) => (
                          <FaStar key={i} color="#036839" />
                        ))}
                      </div>
                      <p className="testimonial-quote">
                        <span className="quote-mark">“</span>
                        {text}
                        <span className="quote-mark">”</span>
                      </p>
                      <p className="author-name">Anonymous</p>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    </>
  );
}
